import { ArenaLockAction, ConfigurationType } from "../constants";

export { buildArenaLockUnlockJobConfig } from "./buildJobConfiguration";
export type { ArenaLockUnlockJobConfig, BuildArenaLockUnlockJobConfigParams } from "../types";
export { validateEmail, validateFiles } from "./validation";

export const isArenaLockAction = (value: string): value is ArenaLockAction => {
  return value === ArenaLockAction.LOCK || value === ArenaLockAction.UNLOCK;
};

export const isConfigurationType = (value: string): value is ConfigurationType => {
  return value === ConfigurationType.DEFAULT || value === ConfigurationType.CUSTOM;
};
